module.exports = __webpack_public_path__ + "static/media/0.ebf4b29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/lhand/0.png
// module id = 1331
// module chunks = 0